import type { CustomCellRendererProps } from "ag-grid-react";
import { clsx } from "clsx";

import style from "../styles/Cell.module.css";
import { getPercentDisplayValue } from "../utils/percent.ts";

export const PercentCell = (props: CustomCellRendererProps) => {
  const percent = getPercentDisplayValue(props.value);

  // Ne need to ellipse, we can't make columns smaller than "XX.XX%"
  return <div className={clsx(style.cell, style.right_aligned)}>{percent}</div>;
};
